import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import grommetMessages from 'grommet/messages/en-US';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import es from 'react-intl/locale-data/es';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';
import { LOCALE_MESSAGE } from './components/common/constants';
import LocaleProvider, { LocaleConsumer } from './context/LocaleContext';

addLocaleData([
  ...en,
  ...zh,
  ...es,
  ...fr,
  ...de
]);

const LanguageProvider = ({ children }) => (
  <LocaleProvider>
    <LocaleConsumer>
      {({ locale }) => (
        <IntlProvider
          textComponent={React.Fragment}
          locale={locale.value}
          messages={{
            ...grommetMessages,
            ...LOCALE_MESSAGE[locale.value]
          }}
        >
          {children}
        </IntlProvider>
)}
    </LocaleConsumer>
  </LocaleProvider>
  );

export default LanguageProvider;